import { FC } from "react";
import { faMap } from "@fortawesome/free-regular-svg-icons";
import orderOptimizerTranslationsHelper from "../../../../../../../../languages/order-optimizer-translations.helper";
import TableLinkButtonComponent from "../../../../../../../../common/components/table/button/link/table-link-button.component";
import {
  OrderOptimizerCargoDetailsItemStepsLastPoint,
  OrderOptimizerCargoDetailsItemStepsOrders,
} from "../../../../common/types/order-optimizer-cargo-details-item";
import orderOptimizerCargoDetailsHelper from "../../../../order-optimizer-cargo-details.helper";

type OrderOptimizerCargoDetailsHiddenDetailsCenterTablesOrdersStepSummaryProps =
  {
    step: OrderOptimizerCargoDetailsItemStepsOrders;
    lastPoint: OrderOptimizerCargoDetailsItemStepsLastPoint | null;
    isABA?: boolean;
  };

const OrderOptimizerCargoDetailsHiddenDetailsCenterTablesOrdersStepSummaryComponent: FC<
  OrderOptimizerCargoDetailsHiddenDetailsCenterTablesOrdersStepSummaryProps
> = (props) => {
  const translations =
    orderOptimizerTranslationsHelper.getCargoDetailsTranslations().table
      .centerTables;

  const totalDriverTime = props.step.totalTime;
  const totalHaltingTime = props.step.haltingTime;
  const totalDistance = props.step.distance;
  const lastPoint = props.step.points[props.step.points.length - 1];

  return (
    <div className="content">
      <div className="human_id" />
      <div className="address" title={translations.summaryLabel}>
        {translations.summaryLabel}
      </div>
      <div className="driver_time">
        {orderOptimizerCargoDetailsHelper.getTimeDeltaLabel(totalDriverTime)}
      </div>
      <div className="driver_halting_time">
        {orderOptimizerCargoDetailsHelper.getTimeDeltaLabel(totalHaltingTime)}
      </div>
      <div className="driver_distance">
        {orderOptimizerCargoDetailsHelper.getDistanceLabel(totalDistance)}
      </div>
      <div className="actions">
        {props.isABA && (
          <TableLinkButtonComponent
            icon={faMap}
            openInNewTab
            to={orderOptimizerCargoDetailsHelper.getGoogleMapsUrl(
              [lastPoint],
              props.lastPoint?.lat,
              props.lastPoint?.lon,
              true
            )}
            type="primary"
          />
        )}
      </div>
    </div>
  );
};

export default OrderOptimizerCargoDetailsHiddenDetailsCenterTablesOrdersStepSummaryComponent;
